import { ConnectedEntities } from "../supportEntitiesTypes"
import { makeStyles } from "tss-react/mui"
import { Link, Typography, Box } from "@mui/material"
import { faCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { tailwindPalette } from "../../../../theme/tailwindPalette"

const useStyles = makeStyles()(() => ({
    containerBorder: {
        borderTop: `1px solid ${tailwindPalette.slate[200]}`,
        paddingTop: "1.5rem",
    },
    entityDetailsLink: {
        color: tailwindPalette.sky[500],
        transition: "all ease-in-out 0.3s",
        "&:hover": {
            color: tailwindPalette.sky[800],
        },
        textDecoration: "none",
    },
    title: {
        fontWeight: 500,
        color: tailwindPalette.slate[700],
        paddingBottom: ".5rem",
        display: "block",
    },
    cellIconDivider: {
        margin: "0 .5rem",
        color: tailwindPalette.slate[300],
    },
}))

export const ConnectedEntitiesComponent = ({
    entities,
    title,
    link,
    borderTop = false,
}: {
    borderTop?: boolean
    entities: ConnectedEntities[]
    title: string
    link: string
}) => {
    const { classes, cx } = useStyles()

    return (
        <Box className={cx(borderTop && classes.containerBorder)}>
            <Typography variant="body2" className={classes.title}>
                {title}:
            </Typography>
            <Box>
                {entities.map((i) => (
                    <Box key={i.id}>
                        <Link
                            href={`${link}/${i.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.entityDetailsLink}
                        >
                            <span>{i.name}</span>
                        </Link>
                        <FontAwesomeIcon className={classes.cellIconDivider} width=".25rem" icon={faCircle} />
                        <LocalizedStrict
                            id="support-entity-details-id"
                            vars={{
                                id: i.id,
                            }}
                        >
                            <span>Id: </span>
                        </LocalizedStrict>
                    </Box>
                ))}
            </Box>
        </Box>
    )
}
